export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "",
        "Adres": "",
        "AI CORE": "",
        "Akcja nie jest obsługiwana.": "",
        "Akwarela": "",
        "Analiza obrazów, rozpoznawanie wzorów wizualnych": "",
        "Angielski": "",
        "Anuluj": "",
        "Asystenta AI": "",
        "Błąd podczas edytowania tekstu": "",
        "Błąd podczas generowania dynamicznego formularza": "",
        "Błąd podczas generowania formularza": "",
        "Błąd podczas generowania metadanych obrazu": "",
        "Błąd podczas pobierania obrazu": "",
        "Błąd podczas wysyłania obrazu": "",
        "Brak brak identyfikatora obrazu": "",
        "Brak kontekstu": "",
        "Brak kroków": "",
        "Brak narzędzia": "",
        "Brak obrazów do zapisania": "",
        "Brak tokenu": "",
        "Brak wymaganych parametrów modelu AI w zapytaniu": "",
        "Chat, wyszukiwanie, generowanie treści, edytor tekstu": "",
        "Claymation": "",
        "Co chcesz wygenerować?": "",
        "Cyberpunk": "",
        "Cyfrowe malarstwo": "",
        "Dane osobowe": "",
        "Data": "",
        "Dla najlepszych wyników opisz obraz w języku angielskim": "",
        "Dodaj dostawcę": "",
        "Dodaj model": "",
        "Dodanie checkbox": "",
        "Dodanie pola adresu": "",
        "Dodanie pola danych osobowych": "",
        "Dodanie pola daty": "",
        "Dodanie pola email": "",
        "Dodanie pola rich-text": "",
        "Dodanie pola tekstowego": "",
        "Dodanie pola telefonu": "",
        "Dodanie strony": "",
        "Domyślny": "",
        "Dostawca": "",
        "Dostawca AI": "",
        "Dostawca AI '${currentAiModelConfig.aiProviderName}' nie zawiera zdefiniowanego klucza API": "",
        "Dostawca AI '${currentAiModelConfig.aiProviderName}' nie został znaleziony": "",
        "Dostawca jest wymagany": "",
        "Edycja tekstu": "",
        "Edytor": "",
        "Edytor tekstu": "",
        "Email": "",
        "Embedding": "",
        "Embedding nie zwrócił prawidłowych danych": "",
        "Endpoint": "",
        "Entuzjastyczny": "",
        "Etykieta": "",
        "Formalny": "",
        "Format obrazu": "",
        "Format wyjściowy": "",
        "Formularz": "",
        "Formularz został wygenerowany, ale nie można go zastosować": "",
        "Fotografia": "",
        "Francuski": "",
        "Generator": "",
        "Generator dynamicznych formularzy": "",
        "Generator metadanych obrazu": "",
        "Generator obrazów": "",
        "Generator obrazów AI": "",
        "Generowana odpowiedź": "",
        "Generowanie formularza": "",
        "Generowanie formularza zakończone.": "",
        "Generowanie i analiza obrazów, grafik": "",
        "Generowanie obrazów zakończone": "",
        "Generowanie treści": "",
        "Generowanie treści...": "",
        "Generowanie zakończone": "",
        "Generuj": "",
        "Generuj formularz": "",
        "Generuj metadane": "",
        "Generuj obraz": "",
        "Generuj treść": "",
        "ID użytkownika": "",
        "Informacje o generatorze": "",
        "Jakość": "",
        "Jakość wyjściowa": "",
        "Kliknij generuj obrazy, aby je tutaj zobaczyć": "",
        "Klucz API": "",
        "Klucz API OpenAI": "",
        "Kompresja wyjściowa": "",
        "Konfiguracja AI jest wyłączona": "",
        "Konfiguracja asystenta ai": "",
        "Konfiguracja nieprawidłowa": "",
        "Konfiguracja prawidłowa": "",
        "Kroki wnioskowania": "",
        "Label musi mieć co najmniej 3 znaki": "",
        "Label nie może być dłuższy niż 100 znaków": "",
        "Liczba kroków wnioskowania": "",
        "Liczba obrazów": "",
        "Liczba wariantów": "",
        "Liczba wyników": "",
        "Low‑poly": "",
        "Medium": "",
        "Megapiksele": "",
        "Model AI '${owner}/${name}' nie został znaleziony dla dostawcy '${provider}'": "",
        "Moderacja": "",
        "Mowa": "",
        "Mowa (TTS)": "",
        "Mroczne fantasy": "",
        "Nazwa": "",
        "Nazwa musi mieć co najmniej 2 znaki": "",
        "Nazwa nie może być dłuższa niż 50 znaków": "",
        "Neutralny": "",
        "Nie można pobrać listy przewidywań: ": "",
        "Nie można pobrać obrazu": "",
        "Nie można pobrać schematu modelu: ": "",
        "Nie skonfigurowano żadnego dostawcy AI. Dodaj przynajmniej jednego dostawcy, aby móc korzystać z narzędzi AI.": "",
        "Nie udało się uzyskać odpowiedzi z API.": "",
        "Nie udało się wygenerować formularza": "",
        "Nie udało się zmienić rozmiaru obrazu": "",
        "Nie znaleziono schematu modelu": "",
        "Nie znaleziono szukanej właściwości schematu wejściowego": "",
        "Nieformalny": "",
        "Niemiecki": "",
        "Nieobsługiwana konfiguracja modelu: ": "",
        "Nieobsługiwane narzędzie: ${body.Tool}": "",
        "Nieobsługiwany provider: ": "",
        "Nieznany": "",
        "Nieznany typ modelu AI": "",
        "Obraz": "",
        "Obraz wejściowy": "",
        "Obraz został pomyślnie opisany": "",
        "Obrazy": "",
        "Obrazy wejściowe": "",
        "Oczekiwanie na odpowiedź...": "",
        "office worker working at a computer": "",
        "Olej na płótnie": "",
        "Opisz formularz": "",
        "Opisz jakie pola powinny znajdować się w formularzu": "",
        "Oryginalny tekst": "",
        "Pixar": "",
        "Pixel art": "",
        "Podstawowe": "",
        "Pola obsługiwane przez generator dynamicznych formularzy.": "",
        "Polski": "",
        "Popraw merytorycznie": "",
        "Pośrednie kroki czasowe": "",
        "Potwierdzenie usunięcia": "",
        "Prompt": "",
        "Proporcje obrazu": "",
        "Prosty": "",
        "Prowadzenie": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Render 3D": "",
        "Repozytorium plików": "",
        "Rozbudowany": "",
        "Rozbuduj tekst": "",
        "Rysunek tuszem": "",
        "Silnik": "",
        "Siła promptu": "",
        "Skala prowadzenia": "",
        "Specjalizowane": "",
        "Sprawdź gramatykę": "",
        "Status": "",
        "Steampunk": "",
        "Streszczenie": "",
        "Strona": "",
        "Struktura": "",
        "Studio Ghibli": "",
        "Styl": "",
        "Styl Tekstu": "",
        "Synteza mowy, konwersja tekstu na głos": "",
        "Synthwave": "",
        "Szerokość": "",
        "Szkic węglem": "",
        "Tak/Nie": "",
        "Tekst": "",
        "Telefon": "",
        "Test konfiguracji przeszedł pomyślnie": "",
        "Test konfiguracji przeszedł z ostrzeżeniami": "",
        "Test konfiguracji zakończył się niepowodzeniem": "",
        "Test ustawień": "",
        "Tło": "",
        "Tłumaczenie": "",
        "Tolerancja bezpieczeństwa": "",
        "Tonalność Tekstu": "",
        "Trwa generowanie formularza": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Trwa generowanie...": "",
        "Trwa testowanie konfiguracji...": "",
        "Tryb szybki": "",
        "TTS nie zwrócił prawidłowego audio stream": "",
        "Tu pojawią się wygenerowane obrazy": "",
        "Tutaj pojawi się wygenerowana treść...": "",
        "Typ": "",
        "Typ musi być jedną z dozwolonych wartości": "",
        "Ulepszanie promptu": "",
        "Ustawienia (opcjonalne)": "",
        "Usuń dostawcę": "",
        "Usuń model": "",
        "Utworzenie formularza": "",
        "Wektoryzacja tekstu, analiza semantyczna": "",
        "Wersja": "",
        "Wersja API": "",
        "Wersja jest wymagana": "",
        "Wersja nie może być dłuższa niż 20 znaków": "",
        "Wierność wejścia": "",
        "Wizja": "",
        "Własne polecenie": "",
        "Właściciel": "",
        "Właściciel musi mieć co najmniej 2 znaki": "",
        "Właściciel nie może być dłuższy niż 50 znaków": "",
        "Wpisz modyfikację np. \"zrób krótsze\", \"dodaj więcej przykładów\"...": "",
        "Wpisz polecenie...": "",
        "Wpisz prompt i kliknij przycisk wyślij aby wygenerować odpowiedź...": "",
        "Wprowadź prompt": "",
        "Wstaw": "",
        "wybierz": "",
        "Wybróbuj możliwości AI": "",
        "Wyczyść wszystkich": "",
        "Wyczyść wszystkie": "",
        "Wygenerowana odpowiedź": "",
        "Wyłącz sprawdzanie bezpieczeństwa": "",
        "Wysokość": "",
        "Wystąpił błąd": "",
        "Wystąpił błąd podczas inicjalizacji pluginu AI.": "",
        "Wystąpił błąd podczas modyfikowania treści": "",
        "Wystąpił problem podczas przesyłania obrazu.": "",
        "Zaawansowany": "",
        "Zamknij": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisywanie obrazów...": "",
        "Zapisz": "",
        "Zapisz wybrane": "",
        "Zaznacz tekst, aby wykonać operację AI.": "",
        "Ziarno": ""
    }
};
